import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import * as lan from '../common/script/common_lan.js';
import axios from 'axios';
import { showAlert } from '../common/script/common';

export default function PaymentNext() {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState('');
    const [buttonText, setButtonText] = useState('');
    const [messageText, setMessageText] = useState('');

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        
        setButtonText('결과 진행중');
        setMessageText('');

        setLoading(false);
    }, [location]);

    const handleStartPayment = () => {
        // 필요한 동작 추가
        console.log('버튼 클릭됨');

    };

    return (
        <>
            <div className="login_head">
                <span></span>
            </div>
            <div id="payment-container" style={{ textAlign: 'center' }}></div>
            <div style={{
                backgroundImage: "url(" + require('../images/bg.png') + ")",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: 'calc(100vh - 60px)',
                display: 'flex',
                flexDirection: 'column',
                color: '#fff',
                textAlign: 'center',
                padding: '1.5rem',
                marginTop: '0.8rem'
            }}>
                <div style={{ flex: 0.8 }}></div>

                {/* 버튼 영역 */}
                {result && (
                    <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <button
                            onClick={handleStartPayment}
                            disabled={loading}
                            style={{
                                backgroundColor: '#1D4ED8',
                                color: '#ffffff',
                                fontSize: '1.125rem',
                                padding: '0.75rem 2rem',
                                border: 'none',
                                borderRadius: '9999px',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                cursor: 'pointer'
                            }}
                        >
                            {buttonText}
                        </button>

                    </div>
                )}
                {messageText && (
                    <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <p
                            style={{
                                marginTop: '0.75rem',
                                whiteSpace: 'pre-wrap',
                                color: '#ffffff',
                                fontSize: '1rem',
                                lineHeight: '1.5',
                                maxWidth: '80%',
                                textAlign: 'center'
                            }}
                        >
                            {messageText}
                        </p>
                    </div>
                )}

                <div style={{flex: 0.4}}></div>
            </div>
        </>
    );
}
